import * as React from 'react';

// Components
import { Link } from 'react-router-dom';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Utils
import { forwardOrAppendAuthParamsIfNotExist } from '@shopee-user/authentication-utils';
import { signupByOTPURL } from '@shopee-user/url';

// Types
import { SignupLinkProps } from '@shopee-user/business-customization-types';

import styles from './style.scss';

export default function SignupLink({ onClick = () => {} }: SignupLinkProps) {
  const I18n = useTranslation();
  const preventFormSubmitOnEnter = (
    event: React.KeyboardEvent<HTMLAnchorElement>
  ) => {
    // prevent pressing enter key from submitting form while link is focused
    if (event.key === 'Enter') {
      event.stopPropagation();
    }
  };

  return (
    <div className={styles.signupPrompt}>
      {I18n.tNode('msg_auth_dont_have_an_account', {
        signup_link: (
          <Link
            className={styles.link}
            to={forwardOrAppendAuthParamsIfNotExist(signupByOTPURL.getUrl())}
            onKeyDown={preventFormSubmitOnEnter}
            onClick={onClick}
          >
            {I18n.t('label_auth_signup')}
          </Link>
        ),
      })}
    </div>
  );
}
